import React, {useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import styled, {css} from 'styled-components';
import linkedin from 'assets/icons/linkedin.svg';
import {CHAT_POPUP, PAGE} from 'common/constants';
import * as globalActions from 'ui/containers/App/actions';
import * as globalSelectors from 'ui/containers/App/selectors';
import {createStructuredSelector} from 'reselect';
import {connect} from 'react-redux';
import {slideUp} from 'styles/animation';
import MessageInput from 'ui/components/MessageInput';
import definite from 'assets/sound/definite.wav';
import closeBlack from 'assets/icons/close.svg';
import ReactHtmlParser from 'react-html-parser';
import {eventTypes} from 'utils/eventTypes';
import {MESSAGE_TYPES, TRIGGER_EVENT_TYPES, WINDOW_POSTMESSAGE_TYPES} from "../App/constants";
import {getFromLocalStorage, saveEventToLocalStorage, saveToLocalStorage,} from 'utils/saveToLocalStorage';
import localStorageTemplates from 'common/local-storage-templates';
import Icon from 'assets/icons/Insent-icon.svg';
import theme from 'styles/theme';
import checkIcon from 'utils/checkIcon';
import InsentAvatar from 'ui/components/Avatar';
import ButtonsMessage from "../../components/ButtonsMessage";
import TextMessage from "../../components/TextMessage";
import * as selectors from "../App/selectors";
import DOMPurify from "dompurify";
import AttachmentMessage from "../../components/AttachmentMessage";
import { postMessageToWindow } from 'utils/index';

const MessageInputContainer = styled.div`
  position: relative;
  top: 4rem;
`;

const AgentTitleNameContainer = styled.div`
  height: 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

const CardCloseIcon = styled.img`
  height: 8px;
  width: 8px;
`;

const GifImage = styled.img`
  max-height: 324px;
  width: 324px;
  border: 2px solid #DADDE4;
  border-radius: 16px 16px 16px 6px;
  display : block;
  ${p => p.contain? `max-width: 100%` : ''};
`;

const MessageElementWrapper = styled(({ lead, leftSpace, messageType, children, align, attachment, ...others }) => (
    <div {...others}>{children}</div>
))`
  float: ${p => (p.lead ? 'right' : 'left')};
  margin: 0;
  width: fit-content;
  & > div {
    ${p => p.attachment ? `max-height: unset !important; max-width: unset !important;`: ''};
  }

  & > div > a {
    ${p => p.attachment ? `height: fit-content !important; max-width: unset !important;` : ''};
  }
  margin-bottom: ${p => (p.messageType === 'buttons' ? '0' : '5px')};
  margin-top: ${p => (p.messageType === 'buttons' ? '0' : '5px')};
  margin-left: ${p => (p.lead ? 'auto' : p.isCalendar ? '0' : p.leftSpace ? '40px' : '0px')};
  ${p => p.align?`align-self:${p.align}`:''};
  ${p => p.align?`margin-right:-10px`:''};
`;

const Card = styled.div`
  margin-top: 20px;
  ${p => p.marginBottom && `margin-bottom: ${p.marginBottom}`};
  position: relative;
  border-radius: 10px;
  width: 100%;
  background-color: ${p => (p.bgColor ? 'white' : 'transparent')};
  ${p => `height: ${p.height};`}
  display: block;
  opacity: ${p => p.opacityValue ? p.opacityValue:0};
  transform: ${p => p.opacityValue ? css`translateY(0px)` : css`translateY(10px)`};
  animation: ${p => (p.opacityValue && p.opacityValue === 1? ``: css`${slideUp} 0.4s ease-in-out 0.1s forwards`)};
  border-radius: 20px;
  ${p => p.paddingTop && `padding-top: ${p.paddingTop}`}
`;


export const PopupMessageDetail = styled.div`
  position: relative;
  z-index: 1 !important;
  height: ${p => (p.height ? p.height : 'calc(100vh - 99px)')};
  background: white;
  border-radius: 20px;
  padding: ${p => p.hasGif ? "8px 16px": "8px 8px 8px 16px"};
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  justify-content: ${p => p.justifyContent || 'center'};
  align-items: center;
  ${p => p.bgColor && `border-bottom: 5px solid ${p.bgColor}; box-shadow: 0px 0px 7px rgba(80, 80, 80, 0.1);`}
`;

export const GreetingMessage = styled.div`
  font-size: 16px;
  margin-right: ${p => p.isFormFactor ? '' : '10px'};
  margin-bottom: 6px;
  width: 100%;
`;

export const PopupContainer = styled(Card)``;

PopupContainer.displayName = 'PopupWrapper';

export const PopupContent = styled.div`
  cursor: pointer;
  color: ${p => p.theme.palette.blue4};
  opacity: 0.8;
  margin-top: 6px;
  word-break: break-word;
  font-size: 14px;
  line-height: 20px;
  opacity: 0.8;
  max-height: ${p => p.isFormFactor?'':'60px'};
  max-width: ${p => p.isFormFactor?'':'240px'};
  padding-right: 2px;
  display: ${p => p.isFormFactor?'flex':'-webkit-box'};
  flex-direction: ${p => p.isFormFactor?'column':''} ;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  white-space: pre-wrap;
  ul, ol {
    margin-bottom: 0px;
    margin-top: 0px;
    padding-left: 25px;
    text-overflow: ellipsis;
  }
`;

PopupContent.displayName = 'PopupContent';

export const PopupAgentWrapper = styled.div`
  display: flex;
  ${p => p.align && `align-items: ${p.align}`}
  width: 100%;
  cursor: pointer;
`;

PopupAgentWrapper.displayName = 'PopupAgentWrapper';

const PopupMessageTextContainer = styled.div`
  background: #edf0f7;
  border-radius: 15px 15px 15px 5px;
  padding: 10px 20px;
  margin: 0 20px;
  margin-bottom: ${p => (p.isLast ? '0' : '10px')};
  display: inline-block;
`;

const PopupMessageArrayContainer = styled.div`
  padding: 0px 20px;
  margin-bottom: ${p => (p.isLast ? '0' : '10px')};
  display: inline-block;
`

export const PopupMessageText = styled.p`
  font-size: 14px;
  color: ${p => p.theme.palette.blue4};
  opacity: 0.8;
  line-height: 18px;
  overflow: hidden;
  margin: 0;
  word-break: break-word;
`;

export const PopupAgentMessageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 0px;
  justify-content: center;
  align-items: center;
`;

PopupAgentMessageWrapper.displayName = 'PopupAgentMessageWrapper';

export const PopupDetail = styled.div`
  width: 100%;
`;

export const PopupTitle = styled.div`
  font-size: 16px;
  font-weight: 700;
  line-height: 19px;
  display: flex;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  display: flex;
`;

PopupTitle.displayName = 'PopupTitle';

export const PopupSenderMessageWrapper = styled.div`
  margin-left: 10px;
  font-size: 16px;
  width: calc(100% - 120px);
  margin-right: 10px;
`;

PopupSenderMessageWrapper.displayName = 'PopupSenderMessageWrapper';

export const PopupBotIcon = styled.img`
  width: 60px;
  margin-left: 5px;
  max-width: 60px;
  max-height: 60px;
`;

export const PopupAgentHeader = styled.div`
  margin-bottom: 0;
  font-size: 20px;
  font-weight: 700;
  line-height: 29px;
`;

export const PopupAgentLinkedinIcon = styled.img`
  margin-left: 0.25rem;
`;

const AgentSubtitle = styled.div`
  font-size: 12px;
  color: ${p => p.theme.palette.blue4};
  opacity: 0.8;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: calc(100vw - 8.5rem);
  margin-top: 6px;
  margin-bottom: 6px;
`;

const AgentTitle = styled.div`
  font-size: 12px;
  line-height: 14px;
  margin: 0;
  margin-top: 4px;
  color: ${p => p.theme.palette.blue4};
  opacity: 0.6;
  height: 16px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const LauncherIconContainer = styled.div`
  background: ${p => p.bgColor};
  border-radius: 20px;
  padding: 10px;
  display: flex;
`;

const LauncherIcon = styled.div`
  background-image: url(${p => p.logo || Icon});
  background-size: contain;
  background-repeat: no-repeat;
  height: 40px;
  width: 40px;
  border-radius: ${p => (p.isIcon ? `0` : `50px`)};
`;


const AgentMessageList = styled.div`
  max-height: 375px;
  overflow-y: auto;
  overflow-x: hidden;
  margin-right: 5px;
  padding-bottom: 10px;
  position: relative;
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track-piece {
    background-color: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #49546526;
    opacity: 0.15;
    border-radius: 30px;
  }
`;

const NewPopup = props => {
    const {
        setActivePageStart,
        currentPage,
        Language,
        popup,
        setSendGreetingMessageAction,
        userData,
        userConfig,
        userSettings,
        userSettingColor,
        currentChannel,
        currentAgent,
        setNotificationRead,
        agentNewMessageList = [],
        setNewAgentMessageList,
        widgetVisibility,
        widgetSound,
        parentFrameSize,
        userSettingBot,
        customCookies,
    } = props;

    let isMobile = parentFrameSize.parentInnerWidth && parseInt(parentFrameSize.parentInnerWidth) <= 480;
    if (popup && popup.mentions) {
        for (let mention of popup.mentions) {
            if (popup.popupMessage.substr(mention.start, mention.end + 1) === `<user:${mention.id}>`) {
                popup.popupMessage =
                    popup.popupMessage.substr(0, mention.start) +
                    '@' +
                    mention.name +
                    popup.popupMessage.substr(mention.end + 1);
            }
        }
    }

    let [hasGif, setHasGif] = useState(false);

    const FadeTopMessageList = styled.div`
      visibility: hidden;
      position: absolute;
      top: 0;
      width: 100%;
      z-index: 12;
      height: 50px;
      background: linear-gradient(180deg, #ffffff 1.64%, rgba(255, 255, 255, 0.0001) 100%);
      border-top-right-radius: 20px;
      border-top-left-radius: 20px;
    `;

    const HeaderHolderBar = styled.div`
      gap: 6px;
      max-width: 280px;
      margin-top: 6px;
      word-break: break-word;
    `;

    const HeaderBotName = styled.p`
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 17px;
      color: #000000;
      margin-block-start: 0;
      margin-block-end: 0;
    `;

    const HeaderCompanyName = styled.span`
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 17px;
      color: #5D626C;
      margin-block-start: 0;
      margin-block-end: 0;
      margin-right: 6px;
    `;

    const CardClose = styled.div`
      visibility: ${isMobile?'visible':'hidden'};
      top: 1px;
      right: 1px;
      cursor: pointer;
      position: absolute;
      display: flex;
      justify-content: center;
      align-items: center;
      background: ${p => p.theme.palette.grey6};
      height: 22px;
      width: 22px;
      border-radius: 50%;
      z-index: ${p => p.theme.zIndex.base2};
      box-shadow: 0px 17px 15px rgba(80, 80, 80, 0.1);
      top: -5px;
      right: -5px;

      &:hover {
        visibility: visible;
      }
    `;

    const GreetingMessageHeaderContainer = styled.div`
      margin: 10px 0px 10px 0px;
      display: flex;
      flex-wrap: wrap;
      gap: 6px;
    `;

    const PopupWrapper = styled.div`
      opacity: 1;
      position: relative;
      margin: 0 20px 20px;
      max-width: 300px;
      width: ${currentPage === PAGE.POPUP_NORMAL ? `max-content` : ''};
      max-width: ${p => p.isFormFactor ? `360px` : `316px`};
      ${p => p.isFormFactor ? `min-width: 227px` : ``};
      border-radius: 30px;
      box-shadow: 0px 5px 10px rgba(80, 80, 80, 0.2);
      &:hover ${CardClose} {
        visibility: visible;
      }
    `;

    const lastMessagesEndRef = useRef(null);
    const popupWrapperRef = useRef(null);
    const greetingMessageRef = useRef(null);
    const fadeTopMessageRef = useRef(null);
    const currentPageRef = useRef();
    const opacityRef = useRef(0);
    const headerTitleRef = useRef(null);
    const headerSubTitleRef = useRef(null);
    const scrollToBottom = () => {
        if (lastMessagesEndRef && lastMessagesEndRef.current) {
            lastMessagesEndRef.current.scrollIntoView();
        }
    };

    useEffect(() => {
        let flag = false;
        if(popup && popup.popupMessage && Array.isArray(popup.popupMessage)){
            popup.popupMessage.forEach(message => {
                if (!!(message && message.gif && Array.isArray(message.gif) && message.gif[0].url)) flag = true;
            })
        }
        setHasGif(flag);
    }, [popup])

    const HandlePopupHeight = () => {
        const type = userConfig.eventListenerName;
        const event = 'iframe-resize';
        if(!popupWrapperRef.current) return;
        let height = popupWrapperRef.current?.clientHeight + 26; // adding 26px considering the margin bottom(20px) and close button(6px)
        let width = popupWrapperRef.current?.clientWidth + CHAT_POPUP.INCREMENT_WIDTH_FORM_FACTOR + 10;
        if(currentPage === PAGE.POPUP_NEW_MESSAGE && width < 376) width = 376;
        if(currentPage === PAGE.POPUP_NEW_MESSAGE && height < 576) height = 576;
        postMessageToWindow({
            type,
            event,
            style: `visibility: visible; height: ${height}px; width: ${width}px; ${userSettingBot.bottomMargin ? `margin-bottom: ${userSettingBot.bottomMargin}px`:''}`
        }, '*');
    }

    const playNotification = async () => {
        if (!widgetVisibility) return;
        try {
            let audio = new Audio(definite);
            if (!audio.isPlaying) {
                await audio.play();
                let widgetPopSoundNoti = JSON.parse(
                    getFromLocalStorage(localStorageTemplates.widgetPopSoundNoti) || '[]'
                );
                widgetPopSoundNoti.push(currentChannel);
                saveToLocalStorage(
                    localStorageTemplates.widgetPopSoundNoti,
                    JSON.stringify(widgetPopSoundNoti)
                );
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        HandlePopupHeight();
        let el = greetingMessageRef.current;
        if(popup && popup.popupMessage && typeof popup.popupMessage === "string") {
            if(el && el.style) el.style.width = (el.clientWidth + 9) + 'px';
        }
    }, [])

    const processUserResponse = (response, type, message) => {
        const text= response[0].text ? response[0].text.toString() : response[0].toString()
        message.text = text;
        message.type = MESSAGE_TYPES.text;
        message.lead = true;
        message.name = null;
        let newMessage = {};
        newMessage[message.key] = [text];
        newMessage.lastMessageTimeStamp = popup.messageTimestamp;
        delete message.buttons;
        setSendGreetingMessageAction({response: newMessage, botMessage: true, message});
    }

    const popupConnectedCloseAction = () => {
        let disabledConversations = JSON.parse(
            getFromLocalStorage(localStorageTemplates.disabledConversations) || '[]'
        );
        disabledConversations.push(currentChannel);
        saveToLocalStorage(
            localStorageTemplates.disabledConversation,
            JSON.stringify(disabledConversations)
        );
        setNotificationRead(1);
        saveToLocalStorage(localStorageTemplates.notificationRead, 1);
        setNewAgentMessageList([]);
        saveEventToLocalStorage({
            eventType: eventTypes.AGENT_CONNECTED_CLOSED,
            timestamp: Date.now(),
            url: userConfig.blogUrl,
            props: {
                ...(currentAgent && currentAgent.agentId && { agentId: currentAgent.agentId }),
                channelId: currentChannel,
            },
        });
        setActivePageStart(PAGE.LAUNCHER);
    };

    const popupNewMessagaCloseAction = () => {
        let disabledConversations = JSON.parse(
            getFromLocalStorage(localStorageTemplates.disabledConversations) || '[]'
        );
        disabledConversations.push(currentChannel);
        saveToLocalStorage(
            localStorageTemplates.disabledConversation,
            JSON.stringify(disabledConversations)
        );
        setNotificationRead(1);
        saveToLocalStorage(localStorageTemplates.notificationRead, 1);

        setActivePageStart(PAGE.LAUNCHER);
    };

    const popupNormalCloseAction = popup => {
        let disabledConversations = JSON.parse(
            getFromLocalStorage(localStorageTemplates.disabledConversations) || '[]'
        );
        disabledConversations.push(currentChannel);
        saveToLocalStorage(
            localStorageTemplates.disabledConversation,
            JSON.stringify(disabledConversations)
        );
        setNotificationRead(1);
        saveToLocalStorage(localStorageTemplates.notificationRead, 1);

        saveEventToLocalStorage({
            eventType: eventTypes.GREETING_MESSAGE_CLOSED,
            timestamp: Date.now(),
            url: userConfig.blogUrl,
            props: {
                channelId: currentChannel,
                greetingMessage: popup.popupMessage,
                stepId: popup.stepId,
                abtestId: popup.abtestId,
                stepUid: popup.stepUid,
                abtestVariantId: popup.abtestVariantId,
            },
        });
        const { eventListenerName } = userConfig;

        postMessageToWindow(
            {
                type: eventListenerName,
                event: WINDOW_POSTMESSAGE_TYPES.triggerEvent,
                eventType: TRIGGER_EVENT_TYPES.greetingMessageClosed,
                eventData: "greeting Message Closed"
            },
            '*'
        );
        setActivePageStart(PAGE.LAUNCHER);
    };

    const popupAgentConnectedClicked = () => {
        const { eventListenerName } = userConfig;
        saveEventToLocalStorage({
            eventType: eventTypes.AGENT_CONNECTED_CLICKED,
            timestamp: Date.now(),
            url: userConfig.blogUrl,
            props: {
                ...(currentAgent && currentAgent.agentId && { agentId: currentAgent.agentId }),
                channelId: currentChannel,
            },
        });
        if(customCookies && Array.isArray(customCookies) && customCookies.length >0) {
            postMessageToWindow(
                {
                    type: eventListenerName,
                    event: WINDOW_POSTMESSAGE_TYPES.getCustomCookies,
                    customCookies,
                },
                '*'
            );
        }
        setActivePageStart(PAGE.CONVO);
        setNewAgentMessageList([]);
    };

    const popupNormalClicked = popup => {
        const event = {
            eventType: eventTypes.GREETING_MESSAGE_CLICKED,
            timestamp: Date.now(),
            url: userConfig.blogUrl,
            props: {
                channelId: currentChannel,
                greetingMessage: popup.popupMessage,
                stepId: popup.stepId,
                abtestId: popup.abtestId,
                abtestVariantId: popup.abtestVariantId,
                stepUid: popup.stepUid,
            },
        };
        const { eventListenerName } = userConfig;
        postMessageToWindow(
            {
                type: eventListenerName,
                event: WINDOW_POSTMESSAGE_TYPES.triggerEvent,
                eventType: TRIGGER_EVENT_TYPES.startConversation,
                eventData: "Conversation Started"
            },
            '*'
        );
        if(customCookies && Array.isArray(customCookies) && customCookies.length >0) {
            postMessageToWindow(
                {
                    type: eventListenerName,
                    event: WINDOW_POSTMESSAGE_TYPES.getCustomCookies,
                    customCookies,
                },
                '*'
            );
        }
        saveEventToLocalStorage(event);
        setActivePageStart(PAGE.CONVO);
    };


    useEffect(() => {
        currentPageRef.current = currentPage;
        if (
            (currentPage === PAGE.POPUP_NORMAL ||
                currentPage === PAGE.POPUP_NEW_MESSAGE ||
                (currentPage === PAGE.POPUP_CONNECTED && widgetVisibility))
            && widgetSound
        ) {
            playNotification();
        }
    }, [currentPage]);

    useEffect(() => {
        if (popup && popup.popupMessage && currentPage === PAGE.POPUP_NORMAL) {
            saveEventToLocalStorage({
                eventType: eventTypes.GREETING_MESSAGE_SHOWN,
                timestamp: Date.now(),
                url: userConfig.blogUrl,
                props: {
                    channelId: currentChannel,
                    greetingMessage: popup.popupMessage,
                    stepId: popup.stepId,
                    stepUid: popup.stepUid,
                    abtestId: popup.abtestId,
                    abtestVariantId: popup.abtestVariantId,
                },
            });
        }

        if(Array.isArray(popup.popupMessage)){
            for(let i=0; i<popup.popupMessage.length; i++){
                if(popup.popupMessage[i].type === "buttons"){
                    saveEventToLocalStorage({
                        eventType: eventTypes.GREETING_MESSAGE_BUTTONS_SHOWN,
                        timestamp: Date.now(),
                        url: userConfig.blogUrl,
                        props: {
                            channelId: currentChannel,
                            greetingMessage: popup.popupMessage,
                            stepId: popup.stepId,
                            stepUid: popup.stepUid,
                            abtestId: popup.abtestId,
                            abtestVariantId: popup.abtestVariantId,
                        },
                    });
                }
                else if(popup.popupMessage[i].type === "gif"){
                    saveEventToLocalStorage({
                        eventType: eventTypes.GIF_IN_GREETING_MESSAGE_SHOWN,
                        timestamp: Date.now(),
                        url: userConfig.blogUrl,
                        props: {
                            channelId: currentChannel,
                            greetingMessage: popup.popupMessage,
                            stepId: popup.stepId,
                            stepUid: popup.stepUid,
                            abtestId: popup.abtestId,
                            abtestVariantId: popup.abtestVariantId,
                        },
                    });
                }
            }

        }

    }, []);

    const setConvoPageActive = () => {
        const { eventListenerName } = userConfig;
        postMessageToWindow(
            {
                type: eventListenerName,
                event: WINDOW_POSTMESSAGE_TYPES.triggerEvent,
                eventType: TRIGGER_EVENT_TYPES.startConversation,
                eventData: "Conversation Started"
            },
            '*'
        );
        if(customCookies && Array.isArray(customCookies) && customCookies.length >0) {
            postMessageToWindow(
                {
                    type: eventListenerName,
                    event: WINDOW_POSTMESSAGE_TYPES.getCustomCookies,
                    customCookies,
                },
                '*'
            );
        }
        setActivePageStart(PAGE.CONVO)
    };

    const handleNewMessageScroll = e => {
        let el = fadeTopMessageRef.current;
        if(e.target.scrollTop > 3) el.style.visibility="visible";
        else el.style.visibility="hidden";

    };

    const renderPopupContent = (popupMessage, isNewMessage = false) => {
        return popupMessage.map((message, index) => {
            switch (message.type) {
                case "text":
                    return (
                        <MessageElementWrapper
                            id="insent-popup-popup-content-message-wrapper"
                            lead={popupMessage.lead}
                            messageType={message.type}
                            key={index}
                        >
                            <TextMessage
                                id="insent-message-container-text-message"
                                userSettingColor={userSettingColor}
                                sender={message.lead ? 'client' : 'server'}
                                text={message.text}
                            />
                        </MessageElementWrapper>
                    )
                case "buttons":
                    return (
                        <MessageElementWrapper
                            id="insent-message-container-message-wrapper"
                            lead={message.lead}
                            messageType={message.type}
                            key={index}
                            align={"flex-end"}
                        >
                            <ButtonsMessage
                                id="insent-message-container-buttons-message"
                                userSettingColor={userSettingColor}
                                grid={true}
                                message={message}
                                processUserResponse={(response, type, message, uid) => {
                                    saveEventToLocalStorage({
                                        eventType: eventTypes.GREETING_MESSAGE_BUTTON_CLICKED,
                                        timestamp: Date.now(),
                                        url: userConfig.blogUrl,
                                        props: {
                                            channelId: currentChannel,
                                            buttonText: message.text,
                                            stepUid: popup.stepUid,
                                            uid: uid
                                        },
                                    });
                                    processUserResponse(response, type, message)
                                }}
                            />
                        </MessageElementWrapper>
                    );
                case "gif":
                    if (message && message.gif && Array.isArray(message.gif) && message.gif[0].url)
                    {
                        return (
                            <GifImage
                                src={message.gif[0].url}
                                alt={message?.gif[0]?.name}
                                onLoad={()=>{
                                    HandlePopupHeight(isNewMessage ? 60 : 0);
                                }}
                                onClick={() => {
                                    saveEventToLocalStorage({
                                        eventType: eventTypes.GIF_IN_GREETING_MESSAGE_CLICKED,
                                        timestamp: Date.now(),
                                        url: userConfig.blogUrl,
                                        props: {
                                            channelId: currentChannel,
                                            buttonText: message.text,
                                            stepUid: popup.stepUid,
                                        },
                                    });
                                }}
                            />
                        );
                    }
                    else if(message && message.type === "gif" && message.publicUrl) {
                        return (
                            <GifImage
                                src={message.publicUrl}
                                alt={message?.name}
                                contain
                                onLoad={()=>{
                                    HandlePopupHeight();
                                }}
                                onClick={() => {
                                    saveEventToLocalStorage({
                                        eventType: eventTypes.GIF_SHOWN,
                                        timestamp: Date.now(),
                                        url: userConfig.blogUrl,
                                        props: {
                                            channelId: currentChannel,
                                            buttonText: message.text,
                                            stepUid: popup.stepUid,
                                        },
                                    });
                                }}
                            />
                        )
                    }
                    else {
                        return;
                    }
                    break;
                default:
                    return (
                        <MessageElementWrapper
                            attachment={true}
                            id="insent-message-container-message-wrapper"
                            lead={message.lead}
                            messageType={message.type}
                            key={index}
                            align={"flex-end"}
                        >
                            <AttachmentMessage
                                message={{attachments: message}}
                                onLoad={()=> {
                                    HandlePopupHeight();
                                }}
                                sender={message.lead ? 'client' : 'server'}
                                userSettingColor={userSettingColor}
                            />
                        </MessageElementWrapper>);
                    break;
            }
        });

    }

    return (
        <div>
            {popup && popup.popupMessage && currentPage === PAGE.POPUP_NORMAL && (
                <PopupWrapper id="insent-popup-wrapper" isFormFactor={Array.isArray(popup.popupMessage)} ref={popupWrapperRef}>
                    <Card id="insent-popup-card" bgColor="white" opacityValue={opacityRef.current}>
                        <PopupMessageDetail
                            id="insent-popup-message-detail"
                            bgColor={userData.settings.color.headerBackgroundColor || theme.palette.primary}
                            height="unset"
                            hasGif={hasGif}
                            justifyContent="space-between"
                            onClick={() => popupNormalClicked(popup)}>
                            <GreetingMessage isFormFactor={Array.isArray(popup.popupMessage)} id="insent-greeting-message">
                                {Array.isArray(popup.popupMessage) &&
                                    <GreetingMessageHeaderContainer>
                                        <InsentAvatar
                                            bgColor={userSettingColor ? userSettingColor.headerBackgroundColor : theme.palette.primary}
                                            size="20"
                                            img={userSettings.bot.img}
                                            name={userSettings.bot.name || 'Bot'}
                                            isBot={true}
                                        />
                                        <HeaderHolderBar>
                                            <HeaderBotName ref={headerTitleRef}>
                                                {userSettings.bot.name}
                                                <HeaderCompanyName ref={headerSubTitleRef}> from {userSettings.bot.company}</HeaderCompanyName>
                                            </HeaderBotName>
                                        </HeaderHolderBar>
                                    </GreetingMessageHeaderContainer>
                                }
                                <PopupContent isFormFactor={Array.isArray(popup.popupMessage)} id="insent-popup-content" ref={greetingMessageRef}>
                                    {typeof popup.popupMessage === "string" && ReactHtmlParser(popup.popupMessage)}
                                    {Array.isArray(popup.popupMessage) && renderPopupContent(popup.popupMessage)}
                                </PopupContent>
                            </GreetingMessage>
                            {typeof popup.popupMessage === "string" && <LauncherIconContainer id="insent-launcher-icon-container" bgColor={userData.settings.color.headerBackgroundColor || theme.palette.primary}>
                                <LauncherIcon id="insent-launcher-icon" logo={userData.settings.bot.widgetIcon || userData.settings.bot.img} isIcon={checkIcon(userData.settings.bot.widgetIcon || userData.settings.bot.img)}/>
                            </LauncherIconContainer>}
                        </PopupMessageDetail>
                    </Card>
                    <CardClose id="insent-popup-card-close" className="card-close" onClick={() => popupNormalCloseAction(popup)} bgClose="white">
                        <CardCloseIcon id="insent-popup-card-close-icon" src={closeBlack} />
                    </CardClose>
                </PopupWrapper>
            )}
            {popup && popup.popupMessage && currentPage === PAGE.POPUP_NEW_MESSAGE && (
                <PopupWrapper ref={popupWrapperRef}>
                    <Card id="insent-popup-card" height="auto" bgColor="white" marginBottom="80px" paddingTop="20px">
                        <FadeTopMessageList id="insent-fade-top-message-list" ref={fadeTopMessageRef} />
                        <AgentMessageList id="insent-agent-message-list" onScroll={handleNewMessageScroll}>
                            {agentNewMessageList.map((agentMessage, agentMessageIndex) => {
                                let isLastMessage = agentNewMessageList.length === (agentMessageIndex + 1);
                                return (
                                    <>
                                        {isLastMessage && (<div ref={lastMessagesEndRef} />)}
                                        <div key={agentMessageIndex} >
                                            {typeof agentMessage === "string" && <PopupMessageTextContainer id={`insent-popup-message-text-container-${agentMessageIndex}`} isLast={agentNewMessageList.length === (agentMessageIndex + 1)}>
                                                <PopupMessageText>{ReactHtmlParser(agentMessage)}</PopupMessageText>
                                            </PopupMessageTextContainer>}
                                            {Array.isArray(agentMessage) && <PopupMessageArrayContainer>{renderPopupContent(agentMessage, true)}</PopupMessageArrayContainer>}
                                        </div>
                                    </>
                                );
                            })}
                        </AgentMessageList>
                        <PopupMessageDetail id="insent-popup-message-detail" height="auto" onClick={setConvoPageActive}>
                            {popup.sender && (
                                <PopupAgentWrapper id="insent-popup-agent-wrapper"  align="center" onClick={popupAgentConnectedClicked}>
                                    <InsentAvatar
                                        id="insent-popup-avatar"
                                        size="40"
                                        img={popup.sender.img}
                                        name={DOMPurify.sanitize(popup?.sender?.name)}
                                    />
                                    <PopupSenderMessageWrapper id="insent-popup-sender-message-wrapper" >
                                        <PopupTitle id="insent-popup-title">
                                            <AgentTitleNameContainer>{DOMPurify.sanitize(popup?.sender?.name)}</AgentTitleNameContainer>
                                            {popup?.sender?.linkedinUrl && (
                                                <div
                                                    dangerouslySetInnerHTML={{__html: `
                                                    <a href="${popup?.sender?.linkedinUrl}" target="_blank" rel="noopener noreferrer">
                                                        <img style="width:16px;height:16px;margin-left: 0.25rem;"
                                                            id="insent-popup-agent-linkedin-icon"
                                                            src=${linkedin}
                                                            alt="linkedin"
                                                        />
                                                    </a>
                                                    `}}
                                                />
                                            )}
                                        </PopupTitle>
                                        {popup.sender.title && (
                                            <AgentTitle>{DOMPurify.sanitize(popup?.sender?.title)}</AgentTitle>
                                        )}
                                    </PopupSenderMessageWrapper>
                                    <LauncherIconContainer id="insent-launcher-icon-container" bgColor={userData?.settings.color.headerBackgroundColor || theme.palette.primary}>
                                        <LauncherIcon id="insent-popup-launcher-icon" logo={userData.settings.bot.widgetIcon || userData.settings.bot.img} isIcon={checkIcon(userData.settings.bot.widgetIcon || userData.settings.bot.img)}/>
                                    </LauncherIconContainer>
                                </PopupAgentWrapper>
                            )}
                        </PopupMessageDetail>
                        <MessageInputContainer id="insent-popup-message-input-container" >
                            <MessageInput
                                id="insent-popup-message-input"
                                Language={Language}
                                type="inputButton"
                                placeholder={`Start your conversation ${popup.sender && popup.sender.name && 'with ' + popup.sender.name}`}
                                bgColor={
                                    userData && userData.settings && userData.settings.color ? userData.settings.color.headerBackgroundColor : '#0A7EF9'
                                }
                                textColor={userData && userData.settings && userData.settings.color ? userData.settings.color.headerTextColor : 'white'}
                                inputButtonClick={setConvoPageActive}
                            />
                        </MessageInputContainer>


                    </Card>
                    <CardClose id="insent-popup-card-close" className="card-close" onClick={popupConnectedCloseAction} bgClose="white">
                        <CardCloseIcon id="insent-popup-card-close-icon" src={closeBlack} />
                    </CardClose>
                </PopupWrapper>
            )}
            {popup && popup.popupMessage && currentPage === PAGE.POPUP_CONNECTED && (
                <PopupWrapper id="insent-popup-wrapper" ref={popupWrapperRef}>
                    <Card id="insent-popup-card" height={popup.sender.title ? "154px" : "144px"}  bgColor="white">
                        <PopupMessageDetail id="insent-popup-message-detail" height="100px" onClick={popupAgentConnectedClicked}>
                            {popup.sender && (
                                <PopupAgentWrapper id="insent-popup-agent-wrapper">
                                    <InsentAvatar
                                        id="insent-popup-insent-avatar"
                                        size="40"
                                        img={popup.sender.img}
                                        name={DOMPurify.sanitize(popup.sender.name)}
                                    />
                                    <PopupSenderMessageWrapper id="insent-popup-sender-message-wrapper" >
                                        <PopupTitle id="insent-popup-title">
                                            <AgentTitleNameContainer>{DOMPurify.sanitize(popup?.sender?.name)}</AgentTitleNameContainer>
                                            {popup?.sender?.linkedinUrl && (
                                                <div
                                                    dangerouslySetInnerHTML={{__html: `
                                                    <a href="${popup?.sender?.linkedinUrl}" target="_blank" rel="noopener noreferrer">
                                                        <img
                                                            style="width:16px;height:16px;margin-left:0.25rem"
                                                            src=${linkedin}
                                                            alt="linkedin"
                                                        />
                                                    </a>
                                                    `}}
                                                />
                                            )}
                                        </PopupTitle>
                                        {popup.sender.title ? (
                                            <>
                                                <AgentTitle id="insent-popup-agent-title" >{DOMPurify.sanitize(popup?.sender?.title)}</AgentTitle>
                                                <AgentSubtitle id="insent-popup-agent-subtitle">{ReactHtmlParser(DOMPurify.sanitize(popup?.popupMessage))}</AgentSubtitle>
                                            </>
                                        ) : (
                                            <PopupContent isFormFactor={Array.isArray(popup.popupMessage)} id="insent-popup-content" ref={greetingMessageRef}>
                                                {typeof popup.popupMessage === "string" && ReactHtmlParser(popup.popupMessage)}
                                                {Array.isArray(popup.popupMessage) && renderPopupContent(popup.popupMessage)}
                                            </PopupContent>
                                        )}
                                    </PopupSenderMessageWrapper>
                                    <LauncherIconContainer id="insent-popup-launcher-icon-container" bgColor={userData && userData.settings && userData.settings.color.headerBackgroundColor || theme.palette.primary}>
                                        <LauncherIcon id="insent-popup-launcher-icon" logo={userData.settings.bot.widgetIcon || userData.settings.bot.img} isIcon={checkIcon(userData.settings.bot.widgetIcon || userData.settings.bot.img)}/>
                                    </LauncherIconContainer>
                                </PopupAgentWrapper>
                            )}
                        </PopupMessageDetail>
                        <MessageInput
                            id="insent-popup-message-input"
                            type="inputButton"
                            placeholder={`Start your conversation ${popup.sender.name && 'with ' + DOMPurify.sanitize(popup?.sender?.name)}`}
                            bgColor={
                                userData && userData.settings && userData.settings.color ? userData.settings.color.headerBackgroundColor : '#0A7EF9'
                            }
                            textColor={userData && userData.settings && userData.settings.color ? userData.settings.color.headerTextColor : 'white'}
                            inputButtonClick={setConvoPageActive}
                        />

                    </Card>
                    <CardClose id="insent-popup-card-close" className="card-close" onClick={popupConnectedCloseAction} bgClose="white">
                        <CardCloseIcon id="insent-popup-card-close-icon" src={closeBlack} />
                    </CardClose>
                </PopupWrapper>
            )}
        </div>
    );
};


NewPopup.propTypes = {
    popup: PropTypes.object,
    currentPage: PropTypes.string,
    setActivePageStart: PropTypes.func,
    pushMessage: PropTypes.func,
    userData: PropTypes.object,
};

export const mapStateToProps = (state, props) => {
    return createStructuredSelector({
        currentPage: globalSelectors.makeSelectCurrentPage(),
        Language: globalSelectors.makeSelectLanguage(),
        userData: globalSelectors.makeSelectCurrentUser(),
        userSettings: globalSelectors.makeSelectCurrentUserSettings(),
        userSettingColor: globalSelectors.makeSelectCurrentUserSettingColor(),
        currentAgent: globalSelectors.makeSelectCurrentAgent(),
        customCookies: globalSelectors.makeSelectCustomCookies(),
        agentNewMessageList: globalSelectors.makeSelectAgentNewMessageList(),
        widgetVisibility: globalSelectors.makeSelectWidgetVisibility(),
        widgetSound: globalSelectors.makeSelectWidgetSound(),
        userConfig: globalSelectors.makeSelectConfig(),
        parentFrameSize: globalSelectors.makeSelectParentFrameSize(),
        userSettingBot: selectors.makeSelectCurrentUserSettingBot(),
    });
};

export const mapDispatchToProps = dispatch => {
    return {
        setActivePageStart: page => dispatch(globalActions.setActivePage.start(page)),
        setNewAgentMessageList: newAgentMessageList => dispatch(globalActions.setAgentMessageList(newAgentMessageList)),
        pushMessage: ({ meta }) => dispatch(globalActions.updateConversationMessages.start({ meta })),
        setSendGreetingMessageAction: message => dispatch(globalActions.setSendGreetingMessageAction(message)),
    };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default withConnect(NewPopup);
